import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ConfigProvider } from "src/app/services/config/config";
import { InstituicaoProvider } from "src/app/services/instituicao/instituicao";

@Pipe({
  name: "phone",
  standalone: true,
})
export class PhonePipe implements PipeTransform {
  objDddi: any;
  objectMask: any;

  constructor(
    public configProvider: ConfigProvider,
    private translate: TranslateService,
    public instituicaoProvider: InstituicaoProvider
  ) {}

  transform(phoneValue: number | string, ddi = null, type = null): string {
    const ddiRecebido = ddi;
    if (!phoneValue) {
      return this.translate.instant("Não Informado");
    }

    let mask = "";
    if (ddiRecebido) {
      const iso2 = (this.instituicaoProvider.objDddi() as { [key: string]: string })[ddiRecebido];
      if (iso2) {
        mask = (this.instituicaoProvider.objectMask() as { [key: string]: string })[iso2];
      }
    }

    if (!mask) {
      mask = "(00)00000-0000";
    }

    const onlyDigits = phoneValue.toString().replace(/\D/g, "");
    let maskedValue = "";
    let digitIndex = 0;

    for (let i = 0; i < mask.length; i++) {
      if (digitIndex >= onlyDigits.length) {
        break;
      }

      if (mask[i] === "0") {
        maskedValue += onlyDigits[digitIndex++];
      } else {
        maskedValue += mask[i];
      }
    }

    return maskedValue;
  }
}
